// eslint-disable-next-line @typescript-eslint/prefer-optional-chain
export default !!(typeof navigator !== 'undefined' &&
navigator.userAgent &&
/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent))
